
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1200 800"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E30A17","d":"M0 0h1200v800H0z"}}),_c('circle',{attrs:{"cx":"425","cy":"400","r":"200","fill":"#fff"}}),_c('circle',{attrs:{"cx":"475","cy":"400","r":"160","fill":"#e30a17"}}),_c('path',{attrs:{"fill":"#fff","d":"M583.334 400l180.901 58.779-111.804-153.885v190.212l111.804-153.885z"}})])
          )
        }
      }
    